import { createSelector } from '@reduxjs/toolkit';

import _ from 'lodash';
import { Tag } from '../../../../general/model';
import { RootSelector, getStore } from '../../../models/rootSelector';
import { SearchShape } from '../model';

export const getSearch: RootSelector<SearchShape> = createSelector(getStore, (x) => x.search);
export const getSearchText: RootSelector<string> = createSelector(
  [getSearch],
  (search) => search.text,
);
export const getInProgress: RootSelector<boolean> = createSelector(
  [getSearch],
  (search) => search.inProgress,
);
export const getTags: RootSelector<Tag[]> = createSelector(getSearch, (s) => s.tags);
export const getTagsById: RootSelector<Record<number, Tag>> = createSelector(getTags, (tags) =>
  _.keyBy(tags, 'id'),
);
